import script from "./attachments-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./attachments-panel.vue?vue&type=script&setup=true&lang=js"

import "./attachments-panel.vue?vue&type=style&index=0&id=6dc9af96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc9af96"]])

export default __exports__